<div class="setup-pass-container">
  <div class="setup-password-form-container">
    <app-mobile-header [title]="'label.setup.password'"></app-mobile-header>

    <div class="setup-password-form-mascot">
      <img src="assets/generalImage/password_lock.svg" loading="lazy" alt="mascot" />
      <h1>{{'desc.setup.password' | translate}}</h1>
    </div>

    <form (ngSubmit)="onSubmit()" [formGroup]="fgroup" class="setupPasswordForm">
      <div class="input-outline">
        <span class="p-float-label">
          <input id="setup-password" [type]="showPw? 'text': 'password'" pInputText formControlName="password"
            #password>
          <label for="setup-password">{{'label.password' | translate}}</label>
        </span>
        <i [ngClass]="{'icon-eye-close': !showPw, 'icon-eye-open': showPw }" (click)="showPw = !showPw"></i>
      </div>

      <div class="password-validation">
        <i class="icon-check-circle" [ngClass]="{'active':  password.value?.length >= 8}"></i>
        <h1>{{'desc.password.length.validation' | translate}}</h1>
      </div>

      <app-button [buttonName]="'button.complete' | translate" (onClickEvent)="onSubmit()" class="complete-btn"
        [disabled]="!fgroup.valid"></app-button>

      <app-button [blackTextButton]="true" [buttonName]="'button.skip' | translate" (onClickEvent)="onSkip()"
        class="skip-btn"></app-button>

    </form>
  </div>

</div>
